module.exports = __webpack_public_path__ + "static/undraw_security_o890-87014e5a43febd27fab032d56fd20785.svg";